import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../shared/HubLayout.css';
import { useMobileSubNav } from '../layout/MobileNavContext';
import { useHubScreen } from '../layout/useHubScreen';
import BackToLotLink from '../shared/lots/BackToLotLink';
import HerdLots, { HerdLotsActions } from './lots/HerdLots.js';
import HerdAnimals, { HerdAnimalsActions } from './animals/HerdAnimals.js';
import HerdProtocolSettings from './HerdProtocolSettings.js';
import Protocols, { ProtocolsActions } from '../reproduction/protocols/Protocols';
import SectionDescription from '../shared/SectionDescription';

const SUB_PATHS = ['animals', 'lots', 'plans', 'settings'];

const SECTION_INFO = [
  { titleKey: 'herd_animals_section_title',   textKey: 'herd_animals_section_text' },
  { titleKey: 'herd_lots_section_title',      textKey: 'herd_lots_section_text' },
  { titleKey: 'herd_plans_section_title',     textKey: 'herd_plans_section_text' },
  { titleKey: 'herd_settings_section_title',  textKey: 'herd_settings_section_text' },
];

export const HerdHub = () => {
  const { t }         = useTranslation();
  const { subTab, screen, setScreen, recordId } = useHubScreen();
  const navigate      = useNavigate();
  const location      = useLocation();
  const { setSubNav } = useMobileSubNav();

  const activeSubTab = Math.max(0, SUB_PATHS.indexOf(subTab));
  const [lotFilter]  = useState(location.state?.lotFilter ?? null);
  const [sexFilter]  = useState(location.state?.sexFilter ?? null);

  const subTabs = [t('animals'), t('herd_lots'), t('plans'), t('settings')];

  const handleSubTabClick = (index) => {
    navigate(`/herd/${SUB_PATHS[index]}`);
  };

  useEffect(() => {
    setSubNav({ tabs: subTabs, activeTab: activeSubTab, onTabClicked: handleSubTabClick });
    return () => setSubNav(null);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeSubTab, setSubNav]);

  return (
    <div className="hub">
      <div className="hub-content">
        {activeSubTab === 0 && (
          <BackToLotLink lotId={lotFilter} prefix={t('herd_lot_prefix')} basePath="/herd/lots" />
        )}
        <SectionDescription
          title={t(SECTION_INFO[activeSubTab].titleKey)}
          text={t(SECTION_INFO[activeSubTab].textKey)}
        />
        {activeSubTab === 0 && (
          <HerdAnimals
            screen={screen}
            setScreen={setScreen}
            initialLotFilter={lotFilter}
            initialSexFilter={sexFilter}
            actions={<HerdAnimalsActions screen={screen} setScreen={setScreen} />}
          />
        )}
        {activeSubTab === 1 && (
          <HerdLots
            screen={screen}
            setScreen={setScreen}
            actions={<HerdLotsActions screen={screen} setScreen={setScreen} />}
          />
        )}
        {activeSubTab === 2 && (
          <Protocols
            planType="general"
            recordId={recordId}
            screen={screen}
            setScreen={setScreen}
            actions={<ProtocolsActions screen={screen} setScreen={setScreen} />}
          />
        )}
        {activeSubTab === 3 && <HerdProtocolSettings />}
      </div>
    </div>
  );
};

export default HerdHub;
